<template>
    <v-dialog v-model="dialog" width="380" @input="limparNovoPedido()">
        <template v-slot:activator="{ on, attrs }">
            <v-btn elevation="0" color="#2BC1B6" height="40"
                   class="btn-criar-pedido white--text" v-bind="attrs" v-on="on">
                Criar pedido
            </v-btn>
        </template>

        <v-card :loading="loadingNewOrder">
            <v-card-title dark class="dialog-titulo">
                Novo pedido
            </v-card-title>
            <v-card-text class="pb-0 mb-0 pt-3 flex-column">
                <v-form ref="formNovoPedido">
                    <span class="dialog-label">Lote</span>
                    <v-autocomplete color="#BDCCCA" outlined dense cache-items hide-no-data persistent-hint
                                    v-model="novoPedido.idLoteProducao" :loading="loading" :rules="[OBRIGATORIO]"
                                    :items="items" :search-input.sync="search"
                                    item-value="idLoteProducao" item-text="jsonProdutor.nmProdutor"
                                    placeholder="Busque pelo nome do Produtor" hint="Somente lotes em aberto">
                        <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                Pesquise pelo nome do produtor
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                  {{ item.jsonProdutor.nmProdutor + ' - UEP: ' +
                                    item.jsonUnidadeExploracao.nrUnidadeExploracao }}
                              </v-list-item-title>
                              <v-list-item-subtitle v-text="item.nrLoteControle"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                    </v-autocomplete>

                    <span class="dialog-label">Data de entrega</span>
                    <menu-datepicker dense outlined v-model="novoPedido.dtSugestaoEntrega" :rules="[OBRIGATORIO, MAIOR_HOJE]"/>

                    <span class="dialog-label">Observação</span>
                </v-form>
            </v-card-text>
            <v-card-actions class="mx-3 pb-4">
                <v-btn class="btn-cancelar" color="#FF5252" outlined @click="dialog = false">
                    Voltar
                </v-btn>
                <v-spacer/>
                <v-btn color="#2BC1B6" :disabled="!validaCampos" elevation="0" class="ml-2 white--text"
                       @click="criarNovoPedido()">
                    Criar Pedido
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import MenuDatepicker from "@/modules/pedidosRacao/components/MenuDatepicker"
import {STRINGS, RULES, URLS} from "@/modules/pedidosRacao/resources";

export default {
    name: 'dialog-novo-pedido',
    components: {MenuDatepicker},
    data: () => ({
        novoPedido: {
            idLoteProducao: 0,
            dtSugestaoEntrega: ''
        },
        dialog: false,
        items: [],
        loading: false,
        loadingNewOrder: false,
        search: null
    }),
    computed: {
        validaCampos() {
            return this.novoPedido.idLoteProducao > 0 && this.novoPedido.dtSugestaoEntrega;
        }
    },
    methods: {
        ...RULES,
        loadLoteProducao: _.debounce( function (val) {
            let query = new URLSearchParams();
            let cfNmProdutor = {"field": "jsonProdutor", "subfield": "nmProdutor", "op": "ilike", "value": '%' +
                    val + '%'};
            let cfSgStatusLote = {"field": "dtFechamentoLote", "op": 'is', "value": null}

            query.append("cf", JSON.stringify(cfSgStatusLote))
            query.append("cf", JSON.stringify(cfNmProdutor))

            this.$axios.get(URLS.LOTEPRODUCAO, { params: query })
                .then((response) => {
                if (!response.data) return
                if (!response.data[0].data) return

                this.items = response.data[0].data;
                })
                .catch( error => {
                    this.$store.commit('setSnack', {type: 'error', msg: error})
                })
                .finally( () => {
                    this.loading = false;
                });
        }, 1000),
        criarNovoPedido() {
            if (!this.$refs.formNovoPedido.validate()) return
            this.loadingNewOrder = true;

            let postData = {
                cdLoteProducao: this.novoPedido.idLoteProducao,
                dtDesejada: this.novoPedido.dtSugestaoEntrega,
                bl_pedido_fabrica: true
            };

            this.$axios.post(URLS.PEDIDORACAO, postData)
                .then((res) => {
                    if (!res.data[0] || !res.data[0].data) return

                    const response = res.data[0].data;

                    this.$router.push(URLS.DETALHEPEDIDO + response.idPedidoRacao);
                })
                .catch( error => {
                    this.$store.commit('setSnack', {type: 'error', msg: 'Não foi possível criar pedido: ' + error})
                })
                .finally( () => {
                    this.loadingNewOrder = false;
                    this.dialog = false
                });
        },
        limparNovoPedido() {
            this.novoPedido = {
                idLoteProducao: 0,
                dtSugestaoEntrega: '',
                dsObservacao: ''
            }
        }
    },
    watch: {
      search (val) {
        this.loading = !val ? false : true;
        if(val && val !== this.select) {
            this.loadLoteProducao(val);
        }
      },
    },
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.dialog-label {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0px;
  color: $gray-300;
}

.dialog-titulo {
  text-align: left;
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
  opacity: 1;
  background-color: $gray-100;
}
</style>